import React, { useRef, useState, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validarCantidad,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoClassVacios from "../../catalogos/catalogoClassVacios";

export const IncluirProducOper = (props) => {
  const token = sessionStorage.getItem("jwtToken");
  const op = require("../../../public/modulos/datos");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  /*  variables de referencias */
  const btnCancelar = useRef();
  const btnAcepta = useRef();

  const txtIdproducto = useRef();
  const txtNombre = useRef();
  const txtCantidad = useRef();
  const txtCantidadExistente = useRef();
  const cmbTipoMovimiento = useRef();
  const txtFecha = useRef();
  const txtNumFactura = useRef();

  /*  variables de estados */
  const [tipoIngreso, setTipoIngreso] = useState([]);
  const [catalogoProducto, setCatalogoProducto] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [labelFecha, setLabelFecha] = useState("FECHA:");
  const [producto, setProducto] = useState({
    idclasevacio: null,
    cantidad: 1.0,
    cantidadE: 0.0,
    cantidadEA: 0.0,
    descripcion: null,
    tipomovimiento: null,
    fechatipomovimiento: null,
    numfactura: null,
  });
  const [habilitadoFec, setHabilitadoFec] = useState(true);
  const [habilitadoFac, setHabilitadoFac] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechaven") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        cmbTipoMovimiento.current.focus();
      } else if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        if (habilitadoFac) {
          txtNumFactura.current.focus();
        } else {
          btnAcepta.current.focus();
        }
      }
      if (event.target.name === "numfactura") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechaven") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      } else if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const validarCantidadP = (event) => {
    event.preventDefault();
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidad({
        index: 0,
        event: event,
        productos: [producto],
        tipo: props.tipo,
      });

      setMensaje(cantidades.msm);
      setProducto(cantidades.data[0]);

      if (cantidades.msm.mostrar) {
        btnCancelar.current.focus();
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let valido = true;
    if (txtIdproducto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtIdproducto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción del Producto no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtNombre.current.focus();
    } else if (txtCantidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (txtCantidad.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe cero",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (
      props.tipo >= 2 &&
      parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")) >
        parseFloat(
          txtCantidadExistente.current.value.replace(".", "").replace(",", ".")
        )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La  cantidad no debe ser mayor a la cantidad existente",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (
      (props.tipo >= 2) &
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex === 0)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex >= 1)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtFecha.current.focus();
    } else if ((txtNumFactura.current.value.trim() === "") & habilitadoFac) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Numero de factura no debe estar vacio",
        ICONO: "INFORMACION",
      });
      valido = false;
      txtNumFactura.current.focus();
    }

    if (valido) {
      let msg = "";
      msg = "El registro fue actualizado.";
      setMensaje({
        mostrar: true,
        titulo: "Exito.",
        texto: msg,
        icono: "exito",
      });
    }
  };

  const blanquear = () => {
    setActivate(false);
    setOperacion(0);
    setTipoIngreso([]);
    setLabelFecha("FECHA:");
    setProducto({
      idclasevacio: null,
      cantidad: 1.0,
      cantidadE: 0.0,
      cantidadEA: 0.0,
      descripcion: null,
      tipomovimiento: null,
      fechatipomovimiento: null,
      numfactura: null,
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const habilitarCampoTipoMov = () => {
    switch (parseInt(cmbTipoMovimiento.current.value)) {
      case 1:
        if (props.tipo == 1) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setLabelFecha("FECHA:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          btnAcepta.current.focus();
        } else if (props.tipo == 2) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setLabelFecha("FECHA DE DESPACHO:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        }

        break;
      case 2:
        if (props.tipo == 1) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setLabelFecha("FECHA DE RECEPCION:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        } else if (props.tipo == 2) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
      case 3:
        if (props.tipo == 1) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      habilitarCampoTipoMov();
    }
  };

  const cerrarModal = () => {
    let datos = [];
    datos.push({
      idclasevacio: producto.idclasevacio,
      descripcion: producto.descripcion,
      cantidad: parseFloat(
        txtCantidad.current.value.replace(".", "").replace(",", ".")
      ),
      tipomovimiento:
        cmbTipoMovimiento.current[cmbTipoMovimiento.current.selectedIndex].text,
      fechatipomovimiento: txtFecha.current.value,
      numfactura: txtNumFactura.current.value,
    });
    props.onHideAcepta(datos);
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarProductoInv = (tecla, idubi) => {
    let codigoproduct = txtIdproducto.current.value.toUpperCase();
    let endpoint = `${op.conexion}/api/inventariovacio/seleccionarproductoinv?idproducto=${codigoproduct}&idalmacen=${idubi}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let prod;
          if (response.data !== "") {
            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "no existe un producto con ese codigo en el almacen.",
                icono: "error",
              });
            } else {
              if (operacion === 1) {
                for (let i = 0; i < props.productos.length; i++) {
                  if (
                    props.productos[i].idclasevacio ===
                    txtIdproducto.current.value.toUpperCase()
                  ) {
                    setActivate(false);
                    setMensaje({
                      mostrar: true,
                      titulo: "Notificacion",
                      texto: "El PRODUCTO YA EXISTE",
                      icono: "error",
                    });
                    txtIdproducto.current.value = "";
                    txtIdproducto.current.focus();
                    txtCantidadExistente.current.value = "0,00";
                    txtCantidad.current.value = "0,00";
                    return;
                  }
                }
              }

              let cantie = response.data.cantidad;

              txtNombre.current.value = response.data.descripcion.trim();
              txtCantidadExistente.current.value = formatMoneda(
                cantie.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              );
              if (tecla === 13) {
                txtCantidad.current.focus();
              }

              prod = {
                idclasevacio: response.data.idclasevacio,
                cantidad: 1.0,
                cantidadE: cantie,
                cantidadEA: parseFloat(response.data.cantidad),
                descripcion: response.data.descripcion,
              };

              setProducto(prod);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un vacio con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        console.log(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarProducto = (event) => {
    event.preventDefault();
    txtNombre.current.value = "";
    txtCantidadExistente.current.value = "0,00";
    txtCantidad.current.value = "0,00";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProductoInv(event.which, props.idalmacen);
      }
    }
  };

  const onCatalogoProducto = (values) => {
    setCatalogoProducto(false);

    txtIdproducto.current.value = values.idclasevacio;
    seleccionarProductoInv(13, props.idalmacen);
  };

  useEffect(() => {
    if (props.tipoingreso) {
      setTipoIngreso(props.tipoingreso);
    }
  }, [props.tipoingreso]);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(0, 0, 0,0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion === 1) {
          txtIdproducto.current.focus();
        } else {
          txtIdproducto.current.value = props.registro.idproducto;
          txtCantidad.current.value = formatMoneda(
            props.registro.cantidad
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          txtFecha.current.value =
            props.registro.fechatipomovimiento === ""
              ? ""
              : moment(props.registro.fechatipomovimiento).format("DD/MM/YYYY");
          txtNumFactura.current.value = props.registro.numfactura.trim();
          for (let i = 0; i < props.tipoingreso.length; i++) {
            if (
              props.tipoingreso[i].descripcion === props.registro.tipomovimiento
            ) {
              cmbTipoMovimiento.current.selectedIndex = i; //props.tipoingreso[i].idtipo;
              break;
            }
          }
          habilitarCampoTipoMov();
          //txtCantidad.current.focus();
          seleccionarProductoInv(13, props.idalmacen);
        }
        setTipoIngreso(props.tipoingreso);
        if (props.tipo === 1) {
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        } else if (props.tipo == 2) {
          setLabelFecha("FECHA DE SALIDA:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        } else if (props.tipo == 3) {
          setLabelFecha("FECHA DE TRASLADO:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        } else {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
          // txtFecha.current.value = "";
          setHabilitadoFec(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Vacios."
            : props.operacion === 2
            ? "Editar Vacios."
            : props.operacion === 3
            ? "Eliminar Vacios."
            : "Consultar Vacios."}
        </Modal.Title>
        <button
          ref={btnCancelar}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>

        <CatalogoClassVacios
          show={catalogoProducto}
          idalmacen={props.tipo === 1 ? null : props.idalmacen}
          onHideCancelar={() => setCatalogoProducto(false)}
          onHideAceptaCatalogo={onCatalogoProducto}
        />
        <div className="border-azul py-3 rounded">
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <div className="row rounded m-0">
              <div className="col-md-12 mb-2">
                <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between">
                  <legend className="float-none w-auto fw-bold">Vacios</legend>

                  <div className="input-group mb-2 col-pd-260 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      CODIGO:
                    </label>
                    <input
                      type="text"
                      ref={txtIdproducto}
                      autoComplete="off"
                      className="form-control text-uppercase h-100 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-default"
                      onChange={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      onKeyUp={validarProducto}
                      onBlur={validarProducto}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setCatalogoProducto(true);
                      }}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>

                  <div className="input-group mb-2 col-pd-700 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                    >
                      DESCRIPCION:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtNombre}
                      className="form-control h-100 fs-5"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-default"
                    />
                  </div>
                </fieldset>
              </div>

              <div className="input-group mb-2 col-pd-300 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  CANTIDAD ACTUAL:
                </label>
                <input
                  type="text"
                  disabled
                  ref={txtCantidadExistente}
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  defaultValue={"0,00"}
                />
              </div>

              <div className="input-group mb-2 col-pd-250 mx-auto">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  CANTIDAD:
                </label>
                <input
                  type="text"
                  ref={txtCantidad}
                  autoComplete="off"
                  className="form-control text-right h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  id="cantidad"
                  onFocus={seleccionarCampo}
                  onKeyUp={validarCantidadP}
                  onBlur={validarCantidadP}
                  defaultValue={"0,00"}
                />
              </div>
              <div className="input-group mb-2 col-pd-410 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  TIPO DE MOVIMIENTO:
                </label>
                <select
                  ref={cmbTipoMovimiento}
                  className="form-select px-1 fs-5"
                  aria-label="Default select example"
                  name="tipo"
                  onChange={onChange}
                >
                  {tipoIngreso &&
                    tipoIngreso.map((tipo) => (
                      <option key={tipo.idtipo} value={tipo.idtipo}>
                        {tipo.descripcion}
                      </option>
                    ))}
                </select>
              </div>

              {labelFecha === "FECHA:" ? (
                <div className="input-group mb-2 col-pd-250 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    {labelFecha}
                  </label>
                  <input
                    type="date"
                    disabled={!habilitadoFec}
                    ref={txtFecha}
                    defaultValue={moment(fechasistema).format("YYYY-MM-DD")}
                    className="form-control h-100 fs-5"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    name="fecha"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              ) : (
                <div className="input-group mb-2 col-pd-360 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    {labelFecha}
                  </label>
                  <input
                    type="date"
                    disabled={!habilitadoFec}
                    ref={txtFecha}
                    defaultValue={moment(fechasistema).format("YYYY-MM-DD")}
                    className="form-control h-100 fs-5"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    name="fecha"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
              )}

              <div className="input-group mb-2 col-pd-300 px-1">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  FACTURA N°:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoFac}
                  ref={txtNumFactura}
                  className="form-control text-uppercase h-100 fs-5"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  name="numfactura"
                  onKeyUp={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancelar}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/almacen/incluirProductoVacio.js